import { MutationTree } from 'vuex';
import { DeviceInfo } from '@/common/apis/DeviceApi';
import { IButtonView, IButtonsViewState } from './types';
import Vue from 'vue';
import _ from 'lodash';

export const mutations: MutationTree<IButtonsViewState> = {
    loaded(state, args: { deviceNumber: string, view: IButtonView }) {
        const clonedView = _.cloneDeep(args.view);
        Vue.set(state.devices, args.deviceNumber, clonedView);
        // state.devices[args.deviceNumber] = args.view;
    },
    setVisibility(state, args: {deviceNumber: string, index: number, hidden: boolean}) {
        const device = state.devices[args.deviceNumber];
        if (device && device.items && device.items[args.index]) {
            Vue.set(device.items[args.index], 'hidden', args.hidden);
        }
    },
    moveUp(state, args: {deviceNumber: string, index: number}) {
        const device = state.devices[args.deviceNumber];
        if (device && device.items && args.index > 0 && device.items.length > args.index) {
            const current = device.items[args.index];
            const swapWith = device.items[args.index - 1];
            Vue.set(device.items, args.index, swapWith);
            Vue.set(device.items, args.index - 1, current);
        }
    },
    moveDown(state, args: {deviceNumber: string, index: number}) {
        const device = state.devices[args.deviceNumber];
        if (device && device.items && args.index >= 0 && device.items.length > args.index + 1) {
            const current = device.items[args.index];
            const swapWith = device.items[args.index + 1];
            Vue.set(device.items, args.index, swapWith);
            Vue.set(device.items, args.index + 1, current);
        }
    },
};
